import { render, staticRenderFns } from "./Flowplayer.vue?vue&type=template&id=7afdc936&scoped=true&"
import script from "./Flowplayer.vue?vue&type=script&lang=js&"
export * from "./Flowplayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afdc936",
  null
  
)

export default component.exports